import React, { PropTypes } from 'react';
import moment from 'moment';

const Simulation = ({ data, invoiceDate }) => {
  const renderIntervalWarning = () => {
    const interventionMoment = moment(invoiceDate, 'DD/MM/YYYY');
    if (
      !interventionMoment.isBetween(
        data.start_date,
        data.end_date,
        'day',
        '[]'
      ) &&
      data.invoice_number
    ) {
      return (
        <p>
          <i className="warning sign yellow icon" />
          <strong>Attention:</strong> la date de facturation n'est pas incluse
          dans la durée du contrat
        </p>
      );
    }
  };

  const invoiceFrequency = ({ invoice_by_intervention, invoice_number }) => {
    if (invoice_by_intervention === true) {
      return 'à la validation des interventions';
    } else {
      return invoice_number;
    }
  };

  const dateFormat = (date, emptyVal) => {
    if (date) {
      return moment(date).format('DD/MM/YYYY');
    } else {
      return emptyVal;
    }
  };

  return (
    <div className="ui segment teal lighten">
      <h4>Dates d'organisation</h4>
      <div className="ui grid">
        <div className="five wide column">
          <p>
            <strong>Date de début</strong>: {dateFormat(data.start_date, '')}
          </p>
        </div>
        <div className="five wide column">
          <p>
            <strong>Date de fin</strong>: {dateFormat(data.end_date, '')}
          </p>
        </div>
        <div className="six wide column">
          <p>
            <strong>Date de réorganisation</strong>:{' '}
            {dateFormat(data.reorg_date, 'Pas de réorganisation')}
          </p>
        </div>
      </div>
      <div className="ui divider" />
      <h4>Nombre d'éléments générés</h4>
      <div className="ui grid">
        <div className="four wide column">
          <p>
            <strong>Factures</strong>: {invoiceFrequency(data)}
          </p>
        </div>
        <div className="eight wide column">{renderIntervalWarning()}</div>
      </div>
    </div>
  );
};

Simulation.propTypes = {
  data: PropTypes.object.isRequired,
  invoiceDate: PropTypes.string.isRequired,
};

export default Simulation;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/forced-invoices-organize/Simulation.js